import { render } from "./ServicesSlider.vue?vue&type=template&id=7ed7f5e7&scoped=true"
import script from "./ServicesSlider.vue?vue&type=script&lang=js"
export * from "./ServicesSlider.vue?vue&type=script&lang=js"

import "./ServicesSlider.vue?vue&type=style&index=0&id=7ed7f5e7&scoped=true&lan=scss&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ed7f5e7"]])

export default __exports__